// import React from "react";
// import TextField from "@mui/material/TextField";

// const InputTextField = ({
//   name,
//   label = "",
//   id,
//   placeholder,
//   type = "text",
//   value,
//   onChange,
//   required,
//   autocomplete = "off",
//   className = "",
//   style,
//   error = "",
//   disabled = false,
//   maxLength,
//   multiline = false,   // ✅ ADD
//   rows = 1,            // ✅ ADD
//   inputProps = {},
// }) => {
//   const hasCustomBg = className
//     .split(" ")
//     .some((cls) => cls.startsWith("bg-") || cls.startsWith("b-"));

//   const finalClassName = `inp-fld mt-2 p-0 c-bk border-0 rounded-2 ${
//     hasCustomBg ? "" : "bg-wl"
//   } ${className}`.trim();

//   return (
//     < >
//       {label && (
//         <label htmlFor={id || name} className="fw-b fs-lg">
//           {label}
//           {required && <span style={{ color: "#fb3b3b" }}>*</span>}
//         </label>
//       )}

//       <TextField
//         fullWidth
//         name={name}
//         id={id || name}
//         type={type}
//         placeholder={placeholder}
//         value={value}
//         multiline={multiline}   // ✅ PASS TO MUI
//         rows={multiline ? rows : undefined} // ✅ SAFE
//         autoComplete={autocomplete}
//         onChange={(e) => {
//           let val = e.target.value;
//               if (type === "file") {
//     onChange(e);   // send original event
//     return;
//   }
//           if (type === "number") {
//             if (val === "0") return;
//             if (val.startsWith("0")) {
//               val = val.replace(/^0+/, "");
//             }
//           }

//           onChange({ target: { name, value: val } });
//         }}
//         className={finalClassName}
//         style={style}
//         disabled={disabled}
//         onKeyDown={(e) => {
//           if (type === "number" && ["-", "+", "e", "E"].includes(e.key)) {
//             e.preventDefault();
//           }
//         }}
//         inputProps={{
//           maxLength,
//           ...inputProps,
//         }}
//         InputLabelProps={{ shrink: false }}
//       />

//       {error && <span className="c-r fs-xs fw-r">{error}</span>}
//     </>
//   );
// };

// export default InputTextField;
import React from "react";
import TextField from "@mui/material/TextField";

const InputTextField = ({
  name,
  label = "",
  id,
  placeholder,
  type = "text",
  value,
  onChange,
  required,
  autocomplete = "off",
  className = "",
  style,
  error = "",
  disabled = false,
  maxLength,
  multiline = false,
  rows = 1,
  inputProps = {},
}) => {
  const hasCustomBg = className
    .split(" ")
    .some((cls) => cls.startsWith("bg-") || cls.startsWith("b-"));

  const finalClassName = `inp-fld mt-2 p-0 c-bk border-0 rounded-2 ${
    hasCustomBg ? "" : "bg-wl"
  } ${className}`.trim();

  return (
    <>
      {label && (
        <label htmlFor={id || name} className="fw-b fs-lg">
          {label}
          {required && (
            <span style={{ color: "#fb3b3b" }}>*</span>
          )}
        </label>
      )}

      <TextField
        fullWidth
        name={name}
        id={id || name}
        type={type}
        placeholder={placeholder}
        value={type !== "file" ? value : undefined}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        autoComplete={autocomplete}
        className={finalClassName}
        style={style}
        disabled={disabled}
        onChange={(e) => {
          /* File Input */
          if (type === "file") {
            onChange(e);
            return;
          }

          let val = e.target.value;

          /* Number Input */
          if (type === "number") {
            if (val === "0") return;

            if (val.startsWith("0")) {
              val = val.replace(/^0+/, "");
            }
          }

          onChange({
            target: {
              name,
              value: val,
            },
          });
        }}
        onKeyDown={(e) => {
          if (
            type === "number" &&
            ["-", "+", "e", "E"].includes(e.key)
          ) {
            e.preventDefault();
          }
        }}
        inputProps={{
          maxLength,
          ...inputProps,
        }}
        InputLabelProps={{ shrink: false }}
      />

      {error && (
        <span className="c-r fs-xs fw-r">
          {error}
        </span>
      )}
    </>
  );
};

export default InputTextField;